import { ScrollButtons } from 'thalia-elements/modules/lists/scroll-buttons/main.js';

class BuchhandlungBilder extends HTMLElement {
    
    constructor() {
        super();
        this.scrollButtons = null;
    }
    connectedCallback() {
        const liste = this.querySelector('.slider-list');
        if (!liste) {
            return;
        }
        this.scrollButtons = new ScrollButtons(liste);
        this.scrollButtons.init();
    }
    disconnectedCallback() {
        this.scrollButtons?.destroy();
    }

}

if (!customElements.get("buchhandlung-bilder")) {
    customElements.define("buchhandlung-bilder", BuchhandlungBilder);
}
